import { render } from "./CreateVersionDocumentationComponent.vue?vue&type=template&id=a3ee4e1c"
import script from "./CreateVersionDocumentationComponent.vue?vue&type=script&lang=js"
export * from "./CreateVersionDocumentationComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__